import { ComponentMap } from '@cinch-nx/data-storyblok'
import {
  AuthorByline,
  CarsCarouselSection,
  CtaButton,
  FaqSection,
  HeroCtaButton,
  HighlightsSection,
  IntroSection,
  RichText,
  TextInlineImage,
  TextInlineImageSection,
} from './blocks'
import Video from '../video/video'

export const storyblokComponents: ComponentMap = {
  AuthorByline,
  CarsCarouselSection,
  CtaButton,
  FaqSection,
  HeroCtaButton,
  HighlightsSection,
  IntroSection,
  LandingTextInlineImage: TextInlineImage,
  LandingTextInlineImageSection: TextInlineImageSection,
  RichText,
  YoutubeVideo: Video,
}
